import React from 'react';
import { hashHistory } from 'react-router';
import { Button, Table, Alert } from 'react-bootstrap';
import '../css/main.css';
import { authContext } from '../AzureAd';

export default class MaintenanceFixTargetComponent extends React.Component {

    // constructor(props) {
    //     super(props);
    // }

    componentWillMount() {
        this.props.findFixableDetails(this.props.request.get('card'),
            this.props.request.get('type'));
    }

    toPreviousPage() {
        hashHistory.push("/fixingCards");
    }

    detailFixed(detail) {
        this.props.detailFixed(detail,
            this.props.response.get("card"),
            this.props.request.get("type"),
            authContext.getCachedUser().userName);
    }

    render() {

        let detailStatus = function (statusKey) {
            switch (statusKey) {
                case 'CREATED': return '未完成';
                case 'FIXED': return '維修完成';
                case 'AUDITED': return '檢點完成';
                default: return '';
            }
        }

        let highlight = function (statusKey) {
            switch (statusKey) {
                case 'CREATED':
                    return {
                        textAlign: "center",
                        backgroundColor: "#FFBFBF",//red
                        verticalAlign: "middle"
                    };
                case 'FIXED':
                    return {
                        textAlign: "center",
                        backgroundColor: "#96FF96",//green
                        verticalAlign: "middle"
                    };
                case 'AUDITED':
                    return {
                        textAlign: "center",
                        backgroundColor: "#EBEBFF",//blue
                        verticalAlign: "middle"
                    };

                default:
                    return {};
            }
        }

        let highlightClassName = function (statusKey) {
            switch (statusKey) {
                case 'CREATED':
                    return "highlight-red";
                case 'FIXED':
                    return "highlight-green";
                case 'AUDITED':
                    return "highlight-blue";
                default:
                    return '';
            }
        }

        let cardStatus = function (status) {
            switch (status) {

                case 'REFINED':
                    return '待維修';
                //return '已確認';

                case 'FIXING':
                    return '維修中';

                case 'FIXED':
                    return '維修完成';

                case 'AUDITED':
                    return '檢點完成';

                default:
                    return "";
            }
        }

        let highlightCard = function (card) {
            if (card == null) {
                return {};
            }
            switch (card.status) {
                case 'REFINED':
                    return {
                        textAlign: "center",
                        backgroundColor: "#FFBFBF",
                    };
                case 'FIXING':
                    return {
                        textAlign: "center",
                        backgroundColor: "#FFE8BF",
                    };
                case 'FIXED':
                case 'AUDITED':
                    return {
                        textAlign: "center",
                        backgroundColor: "#96FF96",
                    };
                default:
                    return {};
            }
        }

        let highlightClassNameCard = function (card) {
            if (card == null) {
                return "";
            }
            switch (card.status) {
                case 'REFINED':
                    return "highlight-red";
                case 'FIXING':
                    return "highlight-brown";
                case 'FIXED':
                case 'AUDITED':
                    return "highlight-green";
                default:
                    return '';
            }
        }

        let alignCenter = {
            textAlign: "center",
            verticalAlign: "middle"
        }

        let card = this.props.response.get("card");

        let titleImg = () => {
            let type = this.props.request.get("type");
            if (type) {
                if ("CLOTH" === type) {
                    return "shirt.svg"
                } else if ("PANT" === type) {
                    return "shorts.svg"
                } else {
                    return "kk25.jpg"
                }
            } else {
                return "kk25.jpg"
            }

        }

        let titleDesc = () => {
            let type = this.props.request.get("type");
            if (type) {
                if ("CLOTH" === type) {
                    return "消防衣"
                } else if ("PANT" === type) {
                    return "消防褲"
                } else {
                    return "Taiwan K.K. "
                }
            } else {
                return "Taiwan K.K. "
            }
        }

        let disabledFixedButton = (detail) => {
            if (detail.status === "CREATED") {
                return false;
            }
            return true;
        }

        let getDetails = () => {
            let ret = this.props.response.get('details');
            if (ret) {
                return ret;
            } else {
                return [];
            }
        }

        return (
            <div>
                <h4><img alt={titleDesc()} src={titleImg()} title={titleDesc()} height="40" width="40" />
                    維修作業 &gt;&gt; 維修卡 &gt;&gt; {card == null ? "" : card.code} {titleDesc()}&nbsp;
                    <a onClick={(e) => { this.toPreviousPage() }}><img src="back.png" title="回上一頁" alt="回上一頁" style={{ cursor: 'pointer' }} /></a>
                </h4>
                <span hidden>MaintenanceFixTargetComponent </span>
                <Alert bsStyle={this.props.alert.get('style')} hidden={this.props.alert.get('message') == null}>
                    {this.props.alert.get('message')}
                </Alert>

                <table className="main">
                <tbody>
                    <tr>
                        <th width="14%">訂單編號</th>
                        <td width="22%">{this.props.request.get("mcase").orderId} {this.props.request.get("mcase").note}</td>
                        <th width="14%">客戶名稱</th>
                        <td width="22%">{this.props.request.get("mcase").customer.customerName}</td>
                        <th width="14%">建立時間</th>
                        <td width="14%">{new Date(this.props.request.get("mcase").createTime).toLocaleDateString()}</td>
                    </tr>
                    <tr>
                        <th width="14%">維修卡號</th>
                        <td width="22%" className={"highlight"} style={{ textAlign: "center" }} >{card == null ? "" : card.code} {titleDesc()}</td>
                        <th width="14%">使用者名</th>
                        <td width="22%">{card == null ? "" : card.owner}</td>
                        <th width="14%">維修卡狀態</th>
                        <td width="14%" style={highlightCard(card)}
                            className={highlightClassNameCard(card)}>{cardStatus(card == null ? "" : card.status)}</td>
                    </tr>
                </tbody>
                </table>

                <h4><img alt={titleDesc()} src={titleImg()} title={titleDesc()} height="40" width="40" />{titleDesc()} {card == null ? "" : card.code} 維修項目</h4>
                <Table striped bordered condensed hover>
                    <thead>
                        <tr>
                            <th width="5%" style={alignCenter}>序號</th>
                            <th width="20%">類別</th>
                            <th width="20%">維修項目</th>
                            <th width="5%">動作</th>
                            <th width="10%">狀態</th>
                            <th>附註</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            getDetails().map(
                                (item, index) =>
                                    <tr key={index}>
                                        <td style={alignCenter}>{index + 1}</td>
                                        <td>{item.checkSet.description}</td>
                                        <td>{item.checkItem.description}</td>
                                        <td>
                                            <Button bsStyle="info"
                                                disabled={disabledFixedButton(item)}
                                                onClick={(event) => {
                                                    this.detailFixed(item);
                                                }}
                                            >
                                                <img alt={titleDesc()} src={titleImg()} height="25" width="25" /> 標記完工
											</Button>
                                        </td>
                                        <td style={highlight(item.status)} className={highlightClassName(item.status)}>{detailStatus(item.status)}</td>
                                        <td>{item.note}</td>
                                    </tr>
                            )
                        }
                    </tbody>
                </Table>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// ./src/components/MaintenanceFixTargetComponent.jsx